import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SEO from '../SEO';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAdmin } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/app/dashboard" replace />;
  return (
    <>
      {/* Defense-in-depth: admin routes already require auth+admin and are
          Disallow'd in robots.txt, but noindex ensures no accidental indexing. */}
      <SEO
        title="FinInteract Admin"
        description="FinInteract internal admin dashboard."
        noIndex
      />
      {children}
    </>
  );
};

export default AdminRoute;
